module.exports = __webpack_public_path__ + "img/stock1.aff7e7de.png";